import { DateTime } from 'luxon';

import { UiDateFormat } from '../constants/app-data.constants';

import { DateTimeHelper } from './date-time-helper';

export class DateTimeValidator {

  // Generic methods

  static validateDateFormat(args: any[]): boolean {

    const formControlValue = this.getFormControlValue(args);
    if (!formControlValue) {
      return true;
    }

    const date = this.getDate(formControlValue);
    return date.isValid;
  }

  static validateDateMustBeGreaterOrEqualThan(args: any[], comparisonDate: DateTime): boolean {

    const formControlValue = this.getFormControlValue(args);
    if (!formControlValue) {
      return true;
    }

    const date = this.getDate(formControlValue);
    if (!date.isValid) {
      return true;
    }

    return date >= comparisonDate;
  }

  // Business-specific methods (these should be eventually moved to a more specific validator class)

  static validateScheduleDate(args: any[]): boolean {

    const formControlValue = this.getFormControlValue(args);
    if (!formControlValue) {
      return true;
    }

    const scheduleDate = this.getDate(formControlValue).endOf('day');
    if (!scheduleDate.isValid) {
      return true;
    }

    const currentDate = DateTimeHelper.now();
    return scheduleDate >= currentDate;
  }

  static validateScheduleDateTooFarAhead(args: any[]): boolean {

    const formControlValue = this.getFormControlValue(args);
    if (!formControlValue) {
      return true;
    }

    const scheduleDate = this.getDate(formControlValue).endOf('day');
    if (!scheduleDate.isValid) {
      return true;
    }

    const currentDate = DateTimeHelper.now();
    const sixMonthsFromNow = currentDate.plus({ months: 6 });
    return scheduleDate <= sixMonthsFromNow;
  }

  // Private methods

  private static getFormControlValue(args: any[]): string {
    return args?.[0]?.formControl?.value;
  }

  private static getDate(formControlValue: string): DateTime {
    return DateTime.fromFormat(formControlValue, UiDateFormat);
  }
}
